import { NgModule } from '@angular/core';
import { Error404Component } from './error404.component';
import { CommonModule } from '@angular/common';
import { UiComponentsModule } from '@shared/ui-components';

const COMPONENTS = [
	Error404Component,

];
@NgModule({
	declarations: [
		...COMPONENTS
	],
	imports: [
		CommonModule,
		UiComponentsModule,
	],
	exports: [...COMPONENTS
	],
})
export class Error404Module { }